(function ($) {
    $(document).ready(function () {
        "use strict";

        $.fn.ekpPage = function () {
            var $self = $(this);

            var $body = $('body');
            var $header = $body.find('.js-bvi-header');
            var CITY_HANDBOOK_URL = '/hdbk/get-cities-paged?countryId=1';
            var FIND_RESULT_URL = '/subject/1/kp/search-events';
            var GET_YEARS_URL = '/subject/1/kp/get-years';
            var HANDBOOK_URL = '/hdbk/handbook-values/';
            var getResultTimeOut;
            var getResultTimeOutDropdownSearch;
            var cityHandbookPagination = false;
            var cityListData = [];
            var classes = {
                contentLoader: '.js-ekp-page-content-ajax-loader',
                contentContainer: '.js-ekp-page-content',
                select: '.js-ekp-page-select',
                selectResult: '.js-ekp-page-select-selected',
                selectLength: '.js-ekp-page-select-length',
                selectOption: '.js-ekp-page-select-option',
                selectInput: '.js-ekp-page-select-input',
                resultLoader: '.js-ekp-page-table-ajax-loader',
                resultContainer: '.js-ekp-page-table',
                resultTotal: '.js-ekp-page-result-total',
                resultTable: '.js-ekp-page-result-table',
                disperseList: '.js-ekp-page-result-disperse',
                dropDownWrapper: '.js-ekp-page-dropdown-wrapper',
                findInput: '.js-ekp-page-input',
                clearButton: '.js-ekp-page-clear',
                showMore: '.js-ekp-page-show-more',
                selectDropDownShowMore: '.js-ekp-page-dropdown-show-more',
                selectDropDownSearch: '.js-ekp-page-select-dropdown-search',
                selectDropDownSubBlock: '.js-ekp-page-dropdown-subselect',
                pagination: '.js-ekp-page-pagination',
            };
            var ESC_KEY_CODE = 27;
            var $contentContainer = $self.find(classes.contentContainer);
            var $contentLoader = $self.find(classes.contentLoader);
            var $select = $self.find(classes.select);
            var $resultLoader = $self.find(classes.resultLoader);
            var $resultContainer = $self.find(classes.resultContainer);
            var $total = $self.find(classes.resultTotal);
            var $table = $self.find(classes.resultTable);
            var $disperseList = $self.find(classes.disperseList);
            var $findInput = $self.find(classes.findInput);
            var $clearButton = $self.find(classes.clearButton);
            var $showMoreCity = $self.find(classes.selectDropDownShowMore);
            var $dropDownSearch = $self.find(classes.selectDropDownSearch);
            var $paginationContainer = $self.find(classes.pagination);

            var nameCountTeam = 'Количество команд';
            var categoryInDesperseDiv = ['Статус мероприятия', 'Тип мероприятия', 'Возраст участников', nameCountTeam, 'Количество участников', 'Регламент'];
            var textInDesperseDiv = [];

            var resultFindItems = [];

            var openClass = 'open';
            var hasDataClass = 'has-data';
            var checkedClass = 'checked';
            var showMoreHidden = 'not-show-more';
            var anyMoreClass = 'any-more';
            var pageSize = null;
            var currentPage = 1;

            /**
             * типы handbook (id)
             * @type {{eventStatus: number, ageGroup: number, eventActivity: number, competitionCategory: number, sportsDiscipline: number}}
             */
            var typesHandbook = {
                sportsDisciplineId: 1,
                eventStatusId: 2,
                competitionCategoryId: 3,
                eventActivityId: 4,
                ageGroupId: 5,
                ageGroupCategoryId: 6,
            };

            var firstOpenPopupDataInMobile = {
                search: null,
                page: 1,
                year: 2024,
                month: null,
                sportsDisciplineId: null,
                eventStatusId: null,
                competitionCategoryId: null,
                eventActivityId: null,
                ageGroupId: [],
                cityId: null,
                ageGroupCategoryId: null,
            }

            /**
             * обьект основного запроса
             * @type {{search: null, ageGroupId: null, month: null, eventStatusId: null, eventActivityId: null, year: null, competitionCategoryId: null, page: null, cityId: null, sportsDisciplineId: null}}
             */
            var searchData = {
                search: null,
                page: 1,
                year: 2024,
                month: null,
                sportsDisciplineId: null,
                eventStatusId: null,
                competitionCategoryId: null,
                eventActivityId: null,
                ageGroupId: [],
                cityId: null,
                ageGroupCategoryId: null,
            };

            /**
             * обьект поиска городов
             * @type {{search: null, page: number}}
             */
            var searchDataCity = {
                page: 1,
                search: null,
            };

            /**
             * преключатель "показать еще " в селекте городов
             * @param show
             */
            var toggleShowMoreButtonCity = function (show) {
                if (show) {
                    $showMoreCity.removeClass(showMoreHidden);
                } else {
                    $showMoreCity.addClass(showMoreHidden);
                }
            }

            /**
             * сколько найдено заполняем
             * @param total
             */
            var pushTotal = function (total) {
                $total.text(total);
            };

            /**
             * забираем span с текстом
             * @param text
             * @returns {string}
             */
            var spanHtml = function (text, elementClass) {
                if (text) {
                    return '<span class="' + elementClass + '">' + text + '</span>';
                } else {
                    return '<span class="' + elementClass + '"></span>';
                }
            };

            /**
             * собираем TD для таблицы
             * @param text
             * @returns {string}
             */
            var getTDInTable = function (text) {
                if (text) {
                    return '<td>' + spanHtml(text) + '</td>';
                } else {
                    return '<td>' + spanHtml() + '</td>';
                }
            };

            /**
             * собираем TR для таблицы
             * @param textArray
             * @returns {string}
             */
            var getTRInTable = function (textArray, id) {
                var tr = '<tr class="disperse" id="disperse-tr-';
                tr = tr + id + '"';
                tr += 'data-disperse-selector="#disperse-table-' + id;
                tr = tr + '">';
                textArray.forEach(function (item) {
                    tr = tr + getTDInTable(item);
                });
                tr = tr + '</tr>';
                return tr;
            };

            /**
             * счетчик выбранных элементов в селекте
             * @param select
             */
            var counterSelectedItems = function (select) {
                var $select = $(select);
                var resultSelected = [];
                var firstValueText = null;
                var $options = $select.find(classes.selectOption);
                var $selectText = $select.find(classes.selectResult);
                var $selectLength = select.find(classes.selectLength);

                $options.each(function () {
                    if ($(this).hasClass(checkedClass)) {
                        if (!firstValueText) {
                            firstValueText = $(this).data('text');
                        }
                        resultSelected.push($(this).data('value'));
                        $select.closest(classes.select).addClass(hasDataClass);
                    }
                });

                if (resultSelected.length > 0) {
                    $select.addClass(hasDataClass);
                    $selectText.text(firstValueText);
                    var lengthText = '';
                    if (resultSelected.length > 1) {
                        lengthText = '+' + (resultSelected.length - 1);
                    }
                    $selectLength.text(lengthText);
                } else {
                    firstValueText = null;
                    $select.removeClass(hasDataClass);
                }
            };

            /**
             * обработчик клика на option
             * @param dataName
             * @param options
             */
            var handlerClickOption = function (dataName, options) {
                var result = [];
                var $parentSelect = $(options).closest(classes.select);
                counterSelectedItems($parentSelect);
                $(options).each(function () {
                    if ($(this).hasClass(checkedClass)) {
                        result.push($(this).data('value'));
                        searchData[dataName] = $(this).data('value');
                    }
                });
                searchData[dataName] = result;

                var hasLoadAgeGroupCategoryIdHandbook = false;
                if (dataName === 'ageGroupId') {
                    hasLoadAgeGroupCategoryIdHandbook = true;
                }
                getResultWithDebounce(hasLoadAgeGroupCategoryIdHandbook);
            };

            /**
             * вешаем обработчики на опции
             * @param options
             * @param dataName
             */
            var addHandlerInOptions = function (options, dataName) {
                var $options = $(options);
                $options.on('click', function () {
                    $(this).toggleClass(checkedClass);
                    handlerClickOption(dataName, $options);
                });
            };

            /**
             * получияем обьект дня/месяца/года из даты
             * @param date
             * @returns {{month: *, year: *, day: *}}
             */
            var getDateObject = function (date) {
                var dateArray = date.split('.');
                return {
                    day: dateArray[0],
                    month: dateArray[1],
                    year: dateArray[2],
                };
            };

            /**
             * собрать дату
             * @param dateStart
             * @param dateEnd
             * @returns {string}
             */
            var getDate = function (dateStart, dateEnd) {
                var date = ' ';
                if (dateStart) {
                    date = date + dateStart;
                }
                if (dateStart && dateEnd) {
                    date = date + '<br>';
                    var objDateStart = getDateObject(dateStart);
                    var objDateEnd = getDateObject(dateEnd);
                    var formatDateStart = Date.parse(new Date(objDateStart.year, objDateStart.month - 1, objDateStart.day));
                    var formatDateEnd = Date.parse(new Date(objDateEnd.year, objDateEnd.month - 1, objDateEnd.day));
                    if (formatDateStart === formatDateEnd) {
                        return date;
                    }
                }
                if (dateEnd) {
                    date = date + dateEnd;
                }
                return date;
            };

            /**
             * див для встраиваемого айтема
             * @param name
             * @param text
             * @returns {string}
             */
            var getDIVForDisperseDiv = function (name, text) {
                if (!text || text.toString().length < 1) {
                    return '<div></div>';
                }
                var styleDisplay = 'block';
                if (name === nameCountTeam && !text) {
                    styleDisplay = 'none';
                }
                var div = '<div class="js-disperse-tr" style="display: ' + styleDisplay + '">';
                div = div + name + ': ' + '<b>' + text + '</b>' + '</div>';
                return div;
            };

            /**
             * заполняем блок 'еще' в таблицы в города
             * @param number
             * @returns {string}
             */
            var moreBlockCityInTable = function (number) {
                var text = '(еще' + ' ' + number + ')';
                return spanHtml(text, anyMoreClass);
            };

            /**
             * заполняем tr таблицу
             * @param item
             */
            var pushTRInTable = function (item) {
                var arrayTop = [];
                arrayTop.push(item.title);
                arrayTop.push(item.sportsDiscipline.join(", "));
                arrayTop.push(item.ageGroup.join(", "));
                arrayTop.push(getDate(item.dateStart, item.dateEnd));
                var cityString = '';
                if (item.city.length > 1) {
                    cityString = item.city[0] + ' ' + moreBlockCityInTable(item.city.length - 1);
                } else {
                    cityString = item.city[0] ? item.city[0] : '';
                }
                arrayTop.push(cityString);
                var tr = getTRInTable(arrayTop, item.id);
                $table.append(tr);
            };

            /**
             * подставляем пробел после каждого 3его символа с конца
             * @param text
             * @returns {string}
             */
            var addSpaceInThreeElements = function (text) {
                var result;
                var resultArray = [];
                var textArray = text.toString().split('').reverse();
                for (var i = 0; i < textArray.length; i++) {
                    resultArray.push(textArray[i]);
                    var count = i + 1;
                    if ((count % 3) === 0) {
                        resultArray.push(' ');
                    }
                }
                result = resultArray.reverse().join('');
                return result;
            };

            /**
             * получить ссылку
             * @param name
             * @param link
             * @returns {string}
             */
            var getLinkDOM = function (name, link) {
                var icon = '<img src="/img/ekp/ic_document.svg">';
                var span = spanHtml(name, '');
                return '<a download class="ekp-document-link" target="_blank" href="' + link + '">' + icon + span + '</a>';
            };

            /**
             *получаем массив данных для disperse блока
             * @param item
             */
            var pushArrayValueForDisperseDiv = function (item) {
                textInDesperseDiv.push(item.eventStatus ? item.eventStatus : '');
                textInDesperseDiv.push((item.competitionCategory ? item.competitionCategory : '') + (item.competitionCategory && item.eventActivity ? ', ' : '') + (item.eventActivity ? item.eventActivity : ' '));
                textInDesperseDiv.push(item.ageGroupRange ? item.ageGroupRange.join(", ") : '');
                textInDesperseDiv.push(item.teamCount ? item.teamCount : '');
                textInDesperseDiv.push(item.participantCount ? addSpaceInThreeElements(item.participantCount) : '');
                if (item.regulationsDocument) {
                    textInDesperseDiv.push(getLinkDOM('Открыть', item.regulationsDocument.url))
                } else {
                    textInDesperseDiv.push('');
                }
            };

            /**
             * получаем левый столбец с данными
             * @returns {string}
             */
            var getLeftDisperseDiv = function () {
                var leftDIV = '<div class="stats-disperse-table-cont__left">';
                for (var i = 0; i < categoryInDesperseDiv.length; i++) {
                    leftDIV += getDIVForDisperseDiv(categoryInDesperseDiv[i], textInDesperseDiv[i]);
                }
                leftDIV += '</div>';
                return leftDIV;
            };

            /**
             * получаем правый столбец с городами
             * @param item
             * @returns {string}
             */
            var getRightDisperseDiv = function (item) {
                var rightDIV = '<div class="stats-disperse-table-cont__right js-right-div-disperse">' + '<span>';
                if (item.city && item.city.length > 1) {
                    item.city.forEach(function (city) {
                        rightDIV += '<div>' + city + '</div>';
                    });
                }
                rightDIV += '</span>' + '</div>';
                return rightDIV;
            };

            /**
             * заполняем список дивов с доп инфой
             * @param item
             */
            var pushDIVinTr = function (item) {
                textInDesperseDiv = [];
                pushArrayValueForDisperseDiv(item);
                var mainDiv = '<div data-type="lineHeight" class="stats-disperse-table-cont" id="disperse-table-';
                mainDiv = mainDiv + item.id + '">';
                var flexDiv = '<div class="stats-disperse-table-cont__flex">';
                flexDiv += getLeftDisperseDiv() + getRightDisperseDiv(item) + '</div>';
                mainDiv += flexDiv + '</div>';
                $disperseList.append(mainDiv);
            };

            /**
             * перебираем данные
             * @param data
             */
            var pushResultTable = function (data) {
                $table.empty();
                $disperseList.empty();
                data.forEach(function (item) {
                    pushTRInTable(item);
                    pushDIVinTr(item);
                });
            };

            /**
             * аккумулируем данные в случае дозагрузки
             * @param items
             */
            var accumulatedFindResult = function (items) {
                items.forEach(function (item) {
                    resultFindItems.push(item);
                });
            };

            /**
             * инициализация пагинации
             */
            var initPagination = function () {
                $paginationContainer.pagination({
                    items: pageSize,
                    currentPage: currentPage,
                    displayedPages: 3,
                    prevText: '<',
                    nextText: '>',
                    ellipsePageSet: false,
                    onPageClick: function (pageNumber, event) {
                        searchData.page = pageNumber;
                        currentPage = pageNumber;
                        getResultWithDebounce();
                        $('html, body').animate({scrollTop: 0}, 500, false);
                    },
                });
            };

            /**
             * основной поиск
             */
            var getResult = function (hasLoadAgeGroupCategoryIdHandbook, accumulated) {
                /* скрываем контейнер с контентом и запускаем лоадер */
                $resultContainer.hide();
                $resultLoader.show();

                $.ajax({
                    url: FIND_RESULT_URL,
                    type: 'GET',
                    data: searchData,
                }).done(function (data) {
                    if (data) {
                        if (accumulated) {
                            accumulatedFindResult(data.results);
                        } else {
                            resultFindItems = data.results;
                        }
                        pushTotal(data.total);
                        pushResultTable(resultFindItems);
                        pageSize = data.pagination.pageCount;
                        initPagination();
                        if (hasLoadAgeGroupCategoryIdHandbook) {
                            getHandbook(typesHandbook.ageGroupCategoryId, null, 'ageGroupCategoryId');
                        }

                        /* По окончанию запроса скрываем лоадер и показываем контент */
                        $resultLoader.hide();
                        $resultContainer.show();
                    }
                });
            };

            /**
             * забираем svg для option
             * @returns {string}
             */
            var checkSVGHtml = function () {
                var check = '<div class="check"><svg><use xlink:href="/img/ekp/ic_option_arrow.svg#ic_option_arrow"></use></svg></div>';
                return check;
            };

            /**
             * строим option
             * @param id
             * @param text
             * @returns {string}
             */
            var getOptionHTML = function (id, text) {
                var option = '<div class="ekp-page-filters__option js-ekp-page-select-option" data-value="';
                option += id + '" data-text="' + text + '">';
                option += checkSVGHtml();
                option += spanHtml(text);
                option += '</div>';
                return option;
            };

            /**
             * заполняем option  в селект
             * @param data
             * @param dataName
             */
            var pushOptionInSelect = function (data, dataName, selectedOption) {
                if (!data) {
                    return;
                }
                $select.each(function () {
                    if ($(this).data('name') === dataName) {
                        var optionWrapper = $(this).find(classes.dropDownWrapper);
                        optionWrapper.empty();
                        if (selectedOption && selectedOption.length > 0) {
                            $(selectedOption).each(function () {
                                optionWrapper.append($(this))
                            })
                        }
                        data.forEach(function (item) {
                            optionWrapper.append(getOptionHTML(item.id, item.text));
                        });
                    }
                });
            };

            /**
             * заполняем мульти селект
             * @param data
             * @param dataName
             */
            var pushOptionMultiSelect = function (data, dataName) {
                if (!data) {
                    return;
                }
                $select.each(function () {
                    if ($(this).data('status') === 'multiselect') {
                        var $subBlock = $(this).find(classes.selectDropDownSubBlock);
                        $subBlock.each(function () {
                            if ($(this).data('name') === dataName) {
                                var $element = $(this);
                                $element.empty();
                                data.forEach(function (item) {
                                    $element.append(getOptionHTML(item.id, item.text));
                                });
                            }
                        });
                    }
                });
            };

            /**
             * заполняем результат городов
             * @param results
             */
            var pushCityResults = function (results) {
                results.forEach(function (item) {
                    cityListData.push(item);
                });
            };

            /**
             * заполняем года
             * @param results
             */
            var pushYearsResults = function (results) {
                var $yearSelect;
                $select.each(function () {
                    if ($(this).data('name') === 'year') {
                        $yearSelect = $(this);
                    }
                });
                if ($yearSelect) {
                    var $dropdown = $yearSelect.find(classes.dropDownWrapper);
                    results.forEach(function (item) {
                        $dropdown.append(getOptionHTML(item, item));
                    });
                    var $options = $dropdown.find(classes.selectOption);
                    var $firstOption = $options.eq(0);
                    $firstOption.addClass(checkedClass);
                    addHandlerInOptions($options, 'year');
                    handlerClickOption('year', $options);
                }
            };

            /**
             * получение списка городов
             */
            var getCityHandbook = function (accumulated, selectedOptions) {
                $.ajax({
                    url: CITY_HANDBOOK_URL,
                    type: 'GET',
                    data: searchDataCity,
                }).done(function (data) {
                    if (data) {
                        cityHandbookPagination = data.pagination;
                        if (accumulated) {
                            pushCityResults(data.results);
                            pushOptionInSelect(cityListData, 'cityId');
                        } else {
                            cityListData = data.results;
                            pushOptionInSelect(cityListData, 'cityId', selectedOptions);
                        }
                        $select.each(function () {
                            if ($(this).data('name') === 'cityId') {
                                var $options = $(this).find(classes.selectOption);
                                addHandlerInOptions($options, 'cityId');
                            }
                        });
                        toggleShowMoreButtonCity(data.pagination.more);
                    }
                });
            };

            /**
             * получить результ годов и заполнить
             */
            var getYearsResult = function () {
                $.ajax({
                    url: GET_YEARS_URL,
                    type: 'get',
                }).done(function (data) {
                    if (data) {
                        pushYearsResults(data.results);
                    }
                });
            };

            /**
             * вешаем обработчики на все опции
             */
            var addHandlerInAllOptions = function () {
                $select.each(function () {
                    var $item = $(this);
                    var selectName = $item.data('name');
                    var $options = $item.find(classes.selectOption);
                    $options.on('click', function () {
                        $(this).toggleClass(checkedClass);
                        handlerClickOption(selectName, $options);
                    });
                });
            };

            /**
             * получение handbnook по типу
             * @param type
             * @param search
             */
            var getHandbook = function (type, search, dataName, selectedOptions) {
                var currentUrl = HANDBOOK_URL + type;
                var sendData = {};
                if (search) {
                    sendData = {
                        search: search,
                    };
                }
                if (type === typesHandbook.ageGroupCategoryId) {
                    sendData.parentId = searchData.ageGroupId;
                }
                $.ajax({
                    url: currentUrl,
                    type: 'GET',
                    data: sendData,
                }).done(function (data) {
                    if (data) {
                        if (type === typesHandbook.competitionCategoryId || type === typesHandbook.eventActivityId) {
                            pushOptionMultiSelect(data.results, dataName);
                            $select.each(function () {
                                if ($(this).data('status') === 'multiselect') {
                                    var $block = $(this).find(classes.selectDropDownSubBlock);
                                    $block.each(function () {
                                        if ($(this).data('name') === dataName) {
                                            var $options = $(this).find(classes.selectOption);
                                            addHandlerInOptions($options, dataName);
                                        }
                                    });
                                }
                            });
                        } else {
                            pushOptionInSelect(data.results, dataName, selectedOptions);
                            $select.each(function () {
                                if ($(this).data('name') === dataName) {
                                    var $options = $(this).find(classes.selectOption);
                                    addHandlerInOptions($options, dataName);
                                }
                            });
                        }
                    }
                });
            };

            /**
             * получение результатов с задержкой и обработка спама запросов
             */
            var getResultWithDebounce = function (hasLoadHandbook, accumulated) {
                if (getResultTimeOut) {
                    clearTimeout(getResultTimeOut);
                }
                getResultTimeOut = window.setTimeout(function () {
                    getResult(hasLoadHandbook, accumulated);
                }, 500);
            };

            /**
             * закрыть все селекты
             */
            var closeAllSelect = function () {
                $select.removeClass(openClass);
            };

            /**
             * обработчик клика на селект
             * @param item
             */
            var handlerClickSelect = function (item) {
                searchData.page = 1;
                if (!$(item).hasClass(openClass)) {
                    closeAllSelect();
                }
                $(item).toggleClass(openClass);
            };

            /**
             * вешаем обработчик на селекты
             */
            var addHandlerInSelect = function () {
                $select.each(function () {
                    var $element = $(this);
                    var $input = $(this).find(classes.selectInput);
                    $input.on('click', function () {
                        handlerClickSelect($element);
                    });
                });
            };

            /**
             * прослушиватель событий на инпуте
             */
            var addHandlerInInput = function () {
                $findInput.on('input', function () {
                    searchData.page = 1;
                    searchData.search = $(this).val();
                    getResultWithDebounce();
                });
            };

            /**
             * очищаем все значения у options
             * @param options
             * @param selectName
             */
            var clearAllOptionsSelect = function (options, selectName) {
                var $options = $(options);
                $options.each(function () {
                    $(this).removeClass(checkedClass);
                });
                handlerClickOption(selectName, $options);
            };

            /**
             * прослушиватель событий на кнопку очистить
             */
            var addHandlerClearButton = function () {
                $clearButton.on('click', function () {
                    searchData.page = 1;
                    closeAllSelect();
                    $findInput.val(null);
                    searchData.search = null;
                    $select.each(function () {
                        var selectName = $(this).data('name');
                        var $options = $(this).find(classes.selectOption);
                        clearAllOptionsSelect($options, selectName);
                    });
                });
            };

            /**
             * первая загрузка на год 2024
             */
            var firstLoadResult = function () {
                $select.each(function () {
                    if ($(this).data('name') === 'year') {
                        var $options = $(this).find(classes.selectOption);
                        $options.each(function () {
                            var $option = $(this);
                            if ($(this).data('value').toString() === '2024') {
                                $option.addClass(checkedClass);
                                handlerClickOption('year', $options);
                            }
                        });
                    }
                });
            };

            /**
             * обработчик на документ клика не на селект
             */
            var addHandlerInDocumentNotInSelect = function () {
                $(document).on('click', function (event) {
                    if ($(event.target).closest(classes.select).hasClass('js-ekp-page-select')) {
                        return;
                    }
                    closeAllSelect();
                });
            };

            /**
             * закрытие документа на ecs
             */
            var addHandlerESCButton = function () {
                $(document).on('keyup', function (event) {
                    if (event.keyCode === ESC_KEY_CODE) {
                        closeAllSelect();
                    }
                });
            };

            /**
             * обработчик показать еще в городах
             */
            var addHandlerOnShowMoreCity = function () {
                $showMoreCity.on('click', function () {
                    searchDataCity.page += 1;
                    getCityHandbook(true);
                });
            };

            /**
             * получение результатов с задержкой и обработка спама запросов
             */
            var getResultWithDebounceDropdownSearch = function (accumulated, callback, selectedOptions) {
                if (getResultTimeOutDropdownSearch) {
                    clearTimeout(getResultTimeOutDropdownSearch);
                }
                getResultTimeOutDropdownSearch = window.setTimeout(function () {
                    callback(accumulated, selectedOptions);
                }, 500);
            };

            /**
             * получить выбранные option
             * @param select
             * @returns {*[]}
             */
            var getCheckedOptions = function (select) {
                var $selectedOptions = [];
                $(select).find(classes.selectOption).each(function () {
                    if ($(this).hasClass(checkedClass)) {
                        $selectedOptions.push($(this));
                    }
                });
                return $selectedOptions;
            };

            /**
             * обрабоичк на поиск в селекте
             * @param parent
             * @param val
             */
            var handlerDropDownSearch = function (parent, val) {
                var $parent = $(parent);
                var selectName = $parent.data('name');
                if (selectName === 'cityId') {
                    searchDataCity.search = val;
                    getResultWithDebounceDropdownSearch(false, getCityHandbook, getCheckedOptions($parent));
                } else {
                    getHandbook(typesHandbook[selectName], val, selectName, getCheckedOptions($parent));
                }
            };

            /**
             * вешаем обработчик на поиски в селекте
             */
            var addHandlerDropDownSearch = function () {
                $dropDownSearch.each(function () {
                    $(this).on('input', function () {
                        var $parent = $(this).closest(classes.select);
                        var value = $(this).val();
                        handlerDropDownSearch($parent, value);
                    });
                });
            };

            var clearHandlerInAllOptions = function () {
                $select.each(function () {
                    var $item = $(this);
                    var selectName = $item.data('name');
                    var $options = $item.find(classes.selectOption);
                    $options.off('click', function () {
                        $(this).toggleClass(checkedClass);
                        handlerClickOption(selectName, $options);
                    });
                });
            };

            /**
             * инициализация логики мобилки
             */
            var initEkpPageMobile = function () {
                var mobileClasses = {
                    filterPopupContainer: '.js-ekp-page-filters-mobile-popup-container',
                    openFilterPopup: '.js-ekp-page-mobile-filter-popup-open',
                    closeFilterPopup: '.js-ekp-page-mobile-filter-popup-close',
                    applyFilterPopup: '.js-ekp-page-mobile-apply'
                };

                var $filterPopupContainer = $self.find(mobileClasses.filterPopupContainer);
                var $openFilterPopupButton = $self.find(mobileClasses.openFilterPopup);
                var $closeFilterPopupButton = $self.find(mobileClasses.closeFilterPopup);
                var $applyFilterPopup = $self.find(mobileClasses.applyFilterPopup);

                var OVERFLOW_HIDDEN_CLASS = 'hidden';
                var ACTIVE_POPUP_CLASS = 'active';
                var OPEN_POPUP_CLASS_FOR_BODY = 'open-ekp-filter';


                /**
                 * добавляем высоту экрана при открытии попапа
                 */
                var addHeightPopupContainer = function () {
                    var mobileDisplayHeight = window.innerHeight;
                    $filterPopupContainer.css({'height': mobileDisplayHeight});
                }

                /**
                 * Функция обработчик открытия попапа с фильтрами
                 */
                var openFilterPopup = function () {
                    if ($filterPopupContainer.hasClass(ACTIVE_POPUP_CLASS)) {
                        return;
                    }
                    $body.addClass(OPEN_POPUP_CLASS_FOR_BODY);
                    $header.addClass(OVERFLOW_HIDDEN_CLASS);
                    addHeightPopupContainer();
                    $filterPopupContainer.addClass(ACTIVE_POPUP_CLASS);
                    for (var key in searchData) {
                        firstOpenPopupDataInMobile[key] = searchData[key];
                    }
                };

                /**
                 * Функция обработчик закрытия попапа с фильтрами
                 */
                var closeFilterPopup = function () {
                    if (!$filterPopupContainer.hasClass(ACTIVE_POPUP_CLASS)) {
                        return;
                    }
                    $body.removeClass(OPEN_POPUP_CLASS_FOR_BODY);
                    $filterPopupContainer.removeClass(ACTIVE_POPUP_CLASS);
                    $header.removeClass(OVERFLOW_HIDDEN_CLASS);
                };

                /**
                 * возвращаем к первым настройкам которые выбрали
                 */
                var returnStartFilterData = function () {
                    $select.each(function () {
                        var selectName = $(this).data('name');
                        var $options = $(this).find(classes.selectOption);
                        clearAllOptionsSelect($options, selectName);
                        var newValueSelect = firstOpenPopupDataInMobile[selectName];
                        if (newValueSelect) {
                            newValueSelect.forEach(function (value) {
                                $options.each(function () {
                                    var $option = $(this);
                                    if ($(this).data('value').toString() === value.toString()) {
                                        $option.addClass(checkedClass);
                                        handlerClickOption(selectName, $options);
                                    }
                                });
                            })
                        }
                    })
                };

                /**
                 * Инициализация событий
                 */
                var initEventListeners = function () {
                    $openFilterPopupButton.on('click', openFilterPopup);
                    $closeFilterPopupButton.on('click', function() {
                        /*
                        * Очищаем фильтры, переходим на 1 страницу пагинации и закрываем модалку
                         */
                        searchData.page = 1;
                        returnStartFilterData();
                        closeAllSelect();

                        closeFilterPopup();
                    });
                    $applyFilterPopup.on('click', closeFilterPopup);
                };

                /**
                 * Инициализация мобильной страницы
                 */
                var initMobilePage = function () {
                    initEventListeners();
                };
                initMobilePage();
            }

            /**
             * инициализация
             */
            var init = function () {
                /**
                 * Если существует класс мобилки, то инициализируем мобилку
                 */
                if ($self.hasClass('js-ekp-page-mobile')) {
                    initEkpPageMobile();
                }

                getCityHandbook();
                for (var key in typesHandbook) {
                    getHandbook(typesHandbook[key], null, key);
                }
                getYearsResult();
                addHandlerInSelect();
                addHandlerInInput();
                addHandlerClearButton();
                addHandlerInDocumentNotInSelect();
                addHandlerESCButton();
                addHandlerOnShowMoreCity();
                addHandlerDropDownSearch();
                addHandlerInAllOptions();
                firstLoadResult();
            };
            init();

            /* после инициализации скрываем лоадер и показываем весь контент */
            $contentContainer.show();
            $contentLoader.hide();
        };
        $('.js-ekp-page').each(function () {
            $(this).data('ekpPage', $(this).ekpPage());
        });
    });
})(jQuery);
